<template>
  <div>
    <div v-if="report">
      <div class="row">
        <div class="col-12">
          <card class="mt-1 font-weight-bold text-muted">
            <report-header/>
          </card>
        </div>
        <div class="col-md-6">
          <card :title="$t('reportingProfileTicketsReport.ticketsReportCard.title')">
            <table>
              <tr>
                <td><h5 class="p-0 m-1">
                  {{ $t('generic.reportGeneratedAt') }}
                </h5></td>
                <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ report.details.generated_at | time }}</h5></td>
              </tr>
              <tr>
                <td><h5 class="p-0 m-1">{{ $t('generic.reportingPeriod') }}</h5>
                </td>
                <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ report.details.from | dateOnly }} - {{
                    report.details.to |
                      dateOnly
                  }}</h5></td>
              </tr>
              <tr>
                <td><h5 class="p-0 m-1">{{
                    $t('reportingProfileTicketsReport.ticketsReportCard.fareGroup')
                  }}</h5></td>
                <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ report.details.fare_group_id }}</h5>
                </td>
              </tr>
              <tr>
                <td><h5 class="p-0 m-1">{{
                    $t('reportingProfileTicketsReport.ticketsReportCard.operator')
                  }}</h5></td>
                <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ report.details.operator_id }}</h5>
                </td>
              </tr>
              <tr>
                <td><h5 class="p-0 m-1">{{
                    $t('reportingProfileTicketsReport.ticketsReportCard.numberOfAccounts')
                  }}</h5></td>
                <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ report.details.profile.accounts.length }}</h5>
                </td>
              </tr>
            </table>
          </card>
        </div>
        <div class="col-md-6"
             v-if="report.details && report.details.profile && report.details.profile.additional_fields">
          <card>
            <table>
              <tbody>
              <tr v-for="(item, key, index) in report.details.profile.additional_fields" :key="index">
                <td><h5 class="p-0 m-1">{{ item.k }}</h5></td>
                <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ item.v }}</h5></td>
              </tr>
              </tbody>
            </table>
          </card>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <card :title="$t('reportingProfileTicketsReport.summaryTableTitle')">
            <el-table :data="report.summary" show-summary :summary-method="getSummaryTableTotal"
                      :empty-text="$t('generic.noData')">
              <el-table-column :label="$t('reportingProfileTicketsReport.tableColumns.fare_id')"
                               prop="fare_id" max-width="300"/>

              <el-table-column :label="$t('reportingProfileTicketsReport.tableColumns.discount_id')"
                               prop="discount_id" :formatter="discountTypesFormatter" max-width="160"/>
              <el-table-column :label="$t('reportingProfileTicketsReport.tableColumns.ticket_type')"
                               prop="ticket_type" :formatter="ticketTypesFormatter" max-width="160"/>

              <el-table-column :label="$t('reportingProfileTicketsReport.tableColumns.tickets_count')"
                               prop="tickets_count" max-width="120"/>

              <el-table-column :label="$t('reportingProfileTicketsReport.tableColumns.ticket_price')"
                               prop="ticket_price" max-width="120"
                               :formatter="moneyFormatter"/>

              <el-table-column :label="$t('reportingProfileTicketsReport.tableColumns.tickets_charge_sum')"
                               max-width="120">
                <span slot-scope="{ row, $index }" :key="$index">{{
                    (row.ticket_price * row.tickets_count) | price
                  }}</span>
              </el-table-column>
            </el-table>
          </card>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <card :title="$t('reportingProfileTicketsReport.ticketsTableTitle')">
            <el-table :data="report.details.data" :empty-text="$t('generic.noData')" show-summary
                      :summary-method="getTicketsTableTotal">
              <el-table-column class-name="nowrap" type="index"/>
              <el-table-column :label="$t('reportingProfileTicketsReport.tableColumns.fare_id')" prop="fare_id"
                               max-width="300"/>
              <el-table-column :label="$t('reportingProfileTicketsReport.tableColumns.discount_id')" prop="discount_id"
                               :formatter="discountTypesFormatter" max-width="160"/>

              <el-table-column :label="$t('reportingProfileTicketsReport.tableColumns.account_identifier')"
                               prop="account_identifier" max-width="160"/>

              <el-table-column :label="$t('reportingProfileTicketsReport.tableColumns.ticket_type')" prop="ticket_type"
                               :formatter="ticketTypesFormatter" width="160"/>

              <el-table-column :label="$t('reportingProfileTicketsReport.tableColumns.tickets_count')"
                               prop="tickets_count" max-idth="100"/>

              <el-table-column :label="$t('reportingProfileTicketsReport.tableColumns.ticket_price')"
                               prop="ticket_price" :formatter="moneyFormatter" max-width="100"/>
              <el-table-column :label="$t('reportingProfileTicketsReport.tableColumns.tickets_charge_sum')"
                               prop="total_tickets_charge" :formatter="moneyFormatter" max-width="120"/>
            </el-table>
          </card>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row mt-5 justify-content-center">
        <div class="col-12">
          <h2 class="text-center">{{ $t('reportingProfileTicketsReport.generatingTitle') }}</h2>
        </div>
        <div class="col-12">
          <p class="text-center">{{ $t('reportingProfileTicketsReport.generatingDescription') }}</p>
        </div>
      </div>
      <div class="row mt-5 justify-content-center">
        <div class="col-12" v-loading="!error && loading"/>
      </div>
    </div>
  </div>
</template>
<script>
import {Table, TableColumn} from 'element-ui';
import {Collapse, CollapseItem} from '@/components';
import ReportHeader from '@/components/ReportHeader/ReportHeader';
import {mapActions, mapState} from "vuex";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Collapse,
    CollapseItem,
    ReportHeader
  },
  data() {
    return {
      report: null,
    };
  },
  mounted() {
    const query = {
      profile_id: this.$route.params.id,
      from: this.$route.query.from,
      to: this.$route.query.to,
      fare_group_id: this.$route.query.fare_group_id,
      operator_id: this.$route.query.operator_id,
    }
    this.GetTicketsReportFromReportingProfile(query)
  },
  methods: {
    ...mapActions(['GetTicketsReportFromReportingProfile']),
    getSummaryTableTotal(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = this.$t('reportingProfileTicketsReport.tableColumns.tickets_charge_sum_total');
            return;
          } else if (index === columns.length - 1) {
            const prices = data.map(item => Number(item['ticket_price']));
            const count = data.map(item => Number(item['tickets_count']));

            sums[index] = 0

            prices.forEach((price, i) => {
              sums[index] = sums[index] + price * count[i]
            });

            sums[index] = this.$options.filters['money'](sums[index])
          } else {
            sums[index] = '';
          }
        }
      );

      return sums;
    },
    getTicketsTableTotal(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
          if (index === 1) {
            sums[index] = this.$t('reportingProfileTicketsReport.tableColumns.tickets_charge_sum_total');
            return;
          } else if (index === columns.length - 1) {
            const prices = data.map(item => Number(item['ticket_price']));
            const count = data.map(item => Number(item['tickets_count']));

            sums[index] = 0

            prices.forEach((price, i) => {
              sums[index] = sums[index] + price * count[i]
            });

            sums[index] = this.$options.filters['money'](sums[index])
          } else {
            sums[index] = '';
          }
        }
      );

      return sums;
    },
    moneyFormatter(row, column, cellValue, index) {
      return this.$options.filters['money'](cellValue);
    },
    discountTypesFormatter(row, column, cellValue, index) {
      return this.$t('discountTypes.' + cellValue);
    },
    ticketTypesFormatter(row, column, cellValue, index) {
      return this.$t('ticketTypes.' + cellValue);
    },
    getPrice(row) {
      let val = -1;
      switch (row.ticket_type) {
        case "single":
          if (row.pricing && row.pricing.single) {
            val = row.pricing.single.price
          }
          break;
        case "month_cap":
          if (row.pricing && row.pricing.caps && row.pricing.caps.calendar_month) {
            val = row.pricing.caps.calendar_month.price
          }
          break;
      }
      return val;
    },
    parsePricing(e) {
      let r = {
        ticket_type: e.ticket_type,
        tickets_count: 0,
        ticket_price: this.getPrice(e),
      }

      return r;
    },
    singlePriceFormatter(row, column, cellValue, index) {
      let val = this.getPrice(row);
      switch (row.ticket_type) {
        case "single":
          if (val < 0) {
            return "unknown single price"
          }
          break;
        case "month_cap":
          if (val < 0) {
            return "unknown month price"
          }
          break;
        default:
          return "unsupported ticket_type"
      }
      return this.$options.filters['money'](val);
    },
  },
  computed: {
    ...mapState({
      loading: state => state.reporting_profile_report.loading,
      error: state => state.reporting_profile_report.error,
      ticketsReportData: state => state.reporting_profile_report.ticketsReportData,
    }),
  },
  watch: {
    ticketsReportData(report) {
      if (!report) {
        return
      }
      // Prepare `accountID -> email` map
      let accountIdIdentifierMap = new Map();
      report.profile.accounts.map(function (accountReport) {
        accountIdIdentifierMap.set(accountReport.account_id, accountReport.identifier);
      });

      // Summary map - fare_id
      let summaryMap = new Map();

      // Prepare pricing and account_identifier and summary.
      report.data.forEach((element) => {
        // Get single price
        let price = this.getPrice(element)
        if (price < 0) {
          element.ticket_price = "unknown"
          return
        }

        element.ticket_price = price

        element.total_tickets_charge = element.ticket_price * element.tickets_count;

        element.account_identifier = accountIdIdentifierMap.get(element.account_id);

        let fareSummary = summaryMap.get(element.fare_id + element.discount_id + element.ticket_type)
        if (!fareSummary) {
          fareSummary = {
            fare_id: element.fare_id,
            fare_group_id: element.fare_group_id,
            discount_id: element.discount_id,
            ...this.parsePricing(element)
          }

          summaryMap.set(element.fare_id + element.discount_id + element.ticket_type, fareSummary)
        }

        fareSummary.tickets_count += element.tickets_count
      });

      let summary = []
      summaryMap.forEach(function (element) {
        summary.push(element)
      })

      const sortedSummary = summary.toSorted((a, b) => {
        return a.fare_group_id.localeCompare(b.fare_group_id)
          || a.discount_id.localeCompare(b.discount_id)
          || a.ticket_type.localeCompare(b.ticket_type)
          || a.ticket_price - b.ticket_price
      });

      // report.data.sort((a, b) => {
      //   return a.account_id > b.account_id;
      // })

      this.report = {
        details: report,
        summary: sortedSummary
      }
    }
  },
};
</script>
<style>
.el-table .nowrap .cell {
  white-space: nowrap;
}
</style>
